import { Button, CircularProgress } from "@mui/material";
import moment from "moment";
import { Header } from "../../../Header";
import "./styles.scss";
import { useLotesUnifacisa } from "./useLotesUnifacisa";

export function LotesUnifacisa() {
  const {
    handleGetLotesRmMv,
    setCodLoteProps,
    handleResponseRmMv,
    handleSendLotesMvRm,
    setMvRmObject,
    loadingRmMv,
    loadingMvRm,
    handleResponseMvRm,
  } = useLotesUnifacisa();
  return (
    <div className="lotes-container">
      <Header message={"Dashboard/Lotes Unifacisa"} showAtualizacao={true} />
      <main>
        <div className="lotes-main-card">
          <h2>Importar lote RM - MV</h2>
          <section className="lotes-main-card-section">
            <input
              type="text"
              onBlur={(e) =>
                setCodLoteProps((prevState) => {
                  return {
                    ...prevState,
                    cod_lote: e.target.value,
                  };
                })
              }
              placeholder="Informe o lote"
              id="lotes-rmmv"
            />
            <input
              type="number"
              onBlur={(e) =>
                setCodLoteProps((prevState) => {
                  return {
                    ...prevState,
                    cod_coligada: Number(e.target.value),
                  };
                })
              }
              placeholder="Informe a coligada"
              id="lotes-rmmv"
            />
            <Button variant="contained" onClick={() => handleGetLotesRmMv()}>
              {loadingRmMv ? (
                <CircularProgress size={18} color="inherit" />
              ) : (
                "Enviar"
              )}
            </Button>
          </section>
          {handleResponseRmMv !== "" && (
            <div className="lotes-main-card-message">
              <p>
                <b>Mensagem:</b> {handleResponseRmMv}
              </p>
            </div>
          )}
        </div>
        <div className="lotes-main-card">
          <h2>Importar lote MV - RM</h2>
          <section className="lotes-main-card-section">
            <div className="lotes-main-card-input-container">
              <p>Data Inicial</p>
              <input
                type="date"
                id="dtInicio-mvrm"
                onBlur={(e) =>
                  setMvRmObject((prevState) => {
                    return {
                      ...prevState,
                      dtInicio: moment(e.target.value).format("DD-MM-yyyy"),
                    };
                  })
                }
              />
            </div>
            <div className="lotes-main-card-input-container">
              <p>Data Final</p>
              <input
                type="date"
                id="dtFim-mvrm"
                onBlur={(e) =>
                  setMvRmObject((prevState) => {
                    return {
                      ...prevState,
                      dtFim: moment(e.target.value).format("DD-MM-yyyy"),
                    };
                  })
                }
              />
            </div>{" "}
            <div className="lotes-main-card-input-container">
              <p>Empresa</p>
              <select
                id="multiEmpresa-mvrm"
                onBlur={(e) =>
                  setMvRmObject((prevState) => {
                    return {
                      ...prevState,
                      cdMultiEmpresa: Number(e.target.value),
                    };
                  })
                }
              >
                <option hidden selected>
                  Selecione
                </option>
                <option value={1}>1-HELP - FUNDACAO PEDRO AMERICO</option>
                <option value={2}>2-FPA CLÍNICA ESCOLA</option>
                <option value={3}>3-HBOL - FUNDACAO PEDRO AMERICO</option>
                <option value={4}>
                  4-HVISAO ACUDE VELHO - HOSP DA VISAO CG
                </option>
                <option value={5}>
                  5-HVISAO HERON MARINHO -HOSP DA VISAO CG
                </option>
              </select>
            </div>
            <Button variant="contained" onClick={() => handleSendLotesMvRm()}>
              {loadingMvRm ? (
                <CircularProgress size={18} color="inherit" />
              ) : (
                "Enviar"
              )}
            </Button>
          </section>
          {handleResponseMvRm !== "" && (
            <div className="lotes-main-card-message">
              <p>
                <b>Mensagem:</b> {handleResponseMvRm}
              </p>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
